import { useMemo } from 'react';
import {
  policyType as PolicyType,
  lookupsJson,
  paymentType as PaymentType,
  allowInstallPayOnHomePoliciesStates,
  onlyPayInFullOnAutoPoliciesStates
} from '@ourbranch/lookups';

const paymentTypeOptionsMap = {
  [PolicyType.Auto]: lookupsJson.autoPaymentType,
  [PolicyType.Home]: lookupsJson.paymentType,
  [PolicyType.Condo]: lookupsJson.paymentType,
  [PolicyType.Renters]: lookupsJson.rentersPaymentType,
  [PolicyType.Farm]: lookupsJson.farmPaymentType,
  [PolicyType.FarmHome]: lookupsJson.farmPaymentType,
  [PolicyType.FarmRental]: lookupsJson.farmPaymentType
};

// `allowMonthlyPayments` is the "Allow Monthly Payments" Policy Override (renewalVariables.allowMonthlyPayments):
// an Underwriting-approved exception that unlocks Monthly on a home policy in a state that no longer
// offers it, the same as a policy already saved as Monthly.
const usePaymentFrequencyOptions = ({ paymentType, policyType, state, allowMonthlyPayments }) =>
  useMemo(() => {
    let isDisabled = false;
    const paymentTypeOptions = paymentTypeOptionsMap[policyType];
    let frequencyOptions = paymentTypeOptions;
    let tooltip = null;

    if (
      policyType === PolicyType.Home &&
      !allowInstallPayOnHomePoliciesStates[state] &&
      paymentType !== PaymentType.Monthly &&
      !allowMonthlyPayments
    ) {
      frequencyOptions = lookupsJson.homeNewBusinessPaymentType;
      isDisabled = true;
      tooltip =
        'Home policies are not eligible to be paid monthly. Payment can be made by mortgage (escrow), or with a one-time payment in full by card or bank withdrawal (ACH).';
    }

    if (
      policyType === PolicyType.Auto &&
      onlyPayInFullOnAutoPoliciesStates[state] &&
      paymentType !== PaymentType.Monthly
    ) {
      frequencyOptions = lookupsJson.autoPaymentType.filter((opt) => opt.id === PaymentType.OneTime);
      isDisabled = true;
      tooltip = 'Auto policies are not eligible to be paid monthly in this state.';
    }

    return { frequencyOptions, isDisabled, tooltip };
  }, [paymentType, policyType, state, allowMonthlyPayments]);

export default usePaymentFrequencyOptions;
